var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "app"
    }
  }, [_c("a-config-provider", {
    attrs: {
      locale: _vm.zhCN
    }
  }, [_c("div", {
    staticClass: "app-wrapper"
  }, [_c("header", {
    staticClass: "app-wrapper__header",
    style: {
      position: _vm.$route.name === "homepage" ? "fixed" : "sticky"
    }
  }, [_c("app-header", {
    on: {
      move: _vm.move
    }
  }), _c("div", {
    staticClass: "top-tips",
    on: {
      click: _vm.stopMove
    }
  }, [_c("a-icon", {
    attrs: {
      type: "exclamation-circle"
    }
  }), _c("span", [_vm._v("您的账号已被冻结，无法正常进行体验与收藏等操作。可能是工作邮箱未认证通过，请联系对接的同花顺销售同事进行处理。")]), _c("a-icon", {
    attrs: {
      type: "close"
    }
  })], 1)], 1), _c("main", {
    staticClass: "app-wrapper__main"
  }, [_c("app-main")], 1), _vm.$route.name !== "details" ? _c("footer", {
    staticClass: "app-wrapper__footer"
  }, [_c("app-footer")], 1) : _vm._e()])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };